var _module_exports = "<modal [header-title]=\"$ctrl.resolve.title\" (on-close)=\"$ctrl.dismiss()\"> <modal-body> <div id=\"map\" style=\"width:100%;height:400px\"></div> </modal-body> </modal>";;
var path = '/app/components/modals/google-maps-modal.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;